// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BrandsEu_TheComp__Mlqoo"};